const segmentReducer = (state = {
    list:[],

}, action) => {

    let newState = state;
    let segments = false;

    switch(action.type) {
        case 'SEGMENT_SET':
            newState = {
                ...state,
                list:action.payload
            }
            break;

        case 'SEGMENT_UPDATE':
            segments = [...state.list];
            segments[action.payload.index] = action.payload.segment;

            newState = {
                ...state,
                list:segments
            }

            break;


    }
    //SEGMENT_UPDATE

    return newState;
}



export default segmentReducer;


// WEBPACK FOOTER //
// ./reducers/segmentReducer.js